import { Box, Center, Checkbox, Flex, Grid, Image, Input, Select, Spinner, Text, useToast } from '@chakra-ui/react'
import { useQuery, useQueryClient } from 'react-query'
import { ModalDeletePost } from './ModalDeletePost'
import { apiBlog } from '../../../services/api'
import { ModalEditPost } from './ModalEditPost'
import { Pagination } from '../../../components/Pagination'
import { useState } from 'react'

export function UpdateExistingPost({ userBlog }) {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const queryClient = useQueryClient()
  const toast = useToast()

  async function getAllPosts(page, limit) {
    const { data } = await apiBlog.get(`/posts?page=${page}&limit=${limit}`)

    return data
  }

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['posts', page, limit],
    queryFn: () => getAllPosts(page, limit),
    refetchOnWindowFocus: false,
    //persiste o dado anterior enquanto o novo dado não chega
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5, // 5 minutos
  })

  async function updateFeaturedPost(id) {
    try {
      const response = await apiBlog.patch(
        `/post/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userBlog.token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      //muda o featured do post para true, e o antigo para false
      queryClient.setQueryData(['posts', page, limit], (oldData) => {
        return {
          ...oldData,
          data: oldData.data.map((post) => {
            if (post.id === id) {
              return {
                ...post,
                featured: !post.featured,
              }
            }

            return post
          }),
        }
      })

      refetch()

      toast({
        title: 'Post atualizado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    } catch (error) {
      console.error(error)

      toast({
        title: 'Erro ao atualizar o post',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  const startPost = Math.min((page - 1) * limit + 1, data?.meta?.totalPosts)
  const endPost = Math.min(page * limit, data?.meta?.totalPosts)

  return (
    <>
      <Flex w="100%" justifyContent="space-between" alignItems="center" mb={5} maxW="1000px" mx="auto">
        <Text fontSize="sm" fontWeight="light" color="gray.500" mr="3">
          {data?.meta?.totalPosts && `${startPost} - ${endPost} de ${data?.meta?.totalPosts} posts`}
        </Text>
        <Pagination limit={data?.meta?.limit} totalPages={data?.meta?.totalPages} totalPosts={data?.meta?.totalPosts} page={page} setPage={setPage} />
        <Flex w="100%" justifyContent="center" alignItems="start" my={5} maxW="300px" flexDir="column" ml="auto">
          <Text>Quantos posts por página?</Text>
          <Select value={limit} onChange={(e) => setLimit(e.target.value)}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </Select>
        </Flex>
      </Flex>

      {isLoading && (
        <Center w="100%">
          <Spinner size="lg" />
        </Center>
      )}
      <Grid templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap={4} maxW="1000px" mx="auto" as="form">
        {isError && <Text>Erro ao carregar os posts.</Text>}
        {!isLoading &&
          data?.data?.map((post) => (
            <Flex
              key={post.id}
              flexDir="column"
              gap={3}
              maxW="450px"
              w="full"
              mx="auto"
              bg="gray.100"
              boxShadow="md"
              p={4}
              minH="450px"
              position="relative"
            >
              <Text fontWeight="bold" mt="50%">
                {post.title}
              </Text>

              <Image
                src={post.imageUrl}
                alt={post.title}
                w="100%"
                objectFit="cover"
                position="absolute"
                top={0}
                left={0}
                bottom={0}
                right={0}
                h="150px"
              />

              <Box dangerouslySetInnerHTML={{ __html: post.content.substring(0, 100).concat('...') }} />

              <Flex gap={2} alignItems="center" mt="auto">
                <label htmlFor="featured">Destaque no Blog</label>
                <Checkbox
                  isChecked={post.featured}
                  id="featured"
                  isDisabled={!userBlog}
                  onChange={(e) => updateFeaturedPost(post.id, e.target.checked)}
                />
              </Flex>

              <Grid gridTemplateColumns={'1fr 1fr'} gap={2}>
                <ModalEditPost userBlog={userBlog} post={post} refetch={refetch} />
                <ModalDeletePost userBlog={userBlog} id={post.id} />
              </Grid>
            </Flex>
          ))}
      </Grid>

      <Flex w="100%" justifyContent="center" alignItems="center" my={5}></Flex>
    </>
  )
}
